<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2">{{text.Title}}</h2>
      <p class="comp-read">{{text.PleaseWait}}</p>
      <p class="comp-read">{{text.ErrorCode}}</p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOError',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      text: {
        Title: null,
        PleaseWait: null,
        ErrorCode: null
      }
    }
  },
  methods: {
    initView: function () {
      const errcode = this.getErrorCode()
      this.text.Title = this.$i18n.t('ErrorPage.Title')
      this.text.PleaseWait = this.$i18n.t('ErrorPage.PleaseWait')
      if (errcode != null) {
        this.text.ErrorCode = this.$i18n.t('ErrorPage.ErrorCode') + errcode
      }
    }
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Error.vue